// The only colour in the UI: task status (its own colour, data: hq.tasks.Status) and graph node kind, muted.

const KIND = {
	light: { Task: "#8a8a8a", Project: "#27272a", Space: "#27272a", Person: "#7c6a9c", Repo: "#5f8a8b", Thread: "#4b6fa8", Member: "#a07a2c" },
	dark: { Task: "#6b6b6b", Project: "#d4d4d8", Space: "#d4d4d8", Person: "#a596c4", Repo: "#86b3b4", Thread: "#7d9bd1", Member: "#c9a55a" },
} as const;

export const EDGE_COLOR = { light: "#c4c4c4", dark: "#3f3f3f" } as const;
export const DEPENDENCY_COLOR = { light: "#c98a84", dark: "#8a4f49" } as const;

export const kindColor = (k: string, dark: boolean) => (KIND[dark ? "dark" : "light"] as Record<string, string>)[k] ?? "#8a8a8a";
